module.exports = __webpack_public_path__ + "img/CHARTS.c2e8252e.svg";